import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

import Loading from '../../components/common/loading';
import config from '../../config/enviroment';
import './styles.scss';
import { queryToObj } from '../../utils/query';

export default function ResetPassword(props) {
    const [backgroundRandom, setBackgroundRandom] = useState(
        Math.floor(Math.random() * 4 + 1),
    );
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [apiBadRequestNotif, setApiBadRequestNotif] = useState(false);
    const [validToken, setValidToken] = useState(false);
    const [secondsRedirect, setSecondsRedirect] = useState(false);
    const [validation, setValidation] = useState(false);
    const [apiGoodRequestNotif, setApiGoodRequestNotif] = useState(false);
    const [requestForm, setRequestForm] = useState({
        token: '',
        password: '',
        passwordConfirmation: '',
    });

    const history = useHistory();

    function axiosRequest() {
        setLoading(true);

        axios
            .post(`${config.authURL}resetpassword`, requestForm)
            .then(_ => {
                setApiBadRequestNotif(false);
                setLoading(false);
                setApiGoodRequestNotif(true);
                setRequestForm({
                    token: '',
                    password: '',
                    passwordConfirmation: '',
                });
            })
            .catch(err => {
                if (
                    err?.response?.data?.message &&
                    err?.response?.data?.additionalData
                ) {
                    setApiBadRequestNotif({
                        message: err?.response?.data?.message,
                        additionalData: err?.response?.data?.additionalData,
                    });
                } else {
                    setApiBadRequestNotif(err?.response?.data?.message);
                }
                setLoading(false);
            });
    }

    function passwordValidation() {
        return {
            validationPassword:
                requestForm.password && requestForm.password.length > 0,
            validationPasswordConfirmation:
                requestForm.password &&
                requestForm.password === requestForm.passwordConfirmation,
        };
    }

    function onSubmit(e) {
        e.preventDefault();
        setValidation(true);

        const { validationPassword, validationPasswordConfirmation } =
            passwordValidation();
        if (validationPassword && validationPasswordConfirmation) {
            axiosRequest();
            setValidation(false);
            setSecondsRedirect(15);
        }
    }

    useEffect(() => {
        async function loadValidToken() {
            let queryToken;
            if (props.location.search) {
                queryToken = queryToObj(props.location.search).token;
                setRequestForm({
                    ...requestForm,
                    token: queryToken,
                });
            }

            try {
                setLoadingPage(true);
                const response = await axios.get(
                    `${config.authURL}checktoken/${queryToken}`,
                );
                if (response.data && response.data.validToken) {
                    setValidToken(true);
                } else {
                    setSecondsRedirect(15);
                }
                setLoadingPage(false);
            } catch (err) {
                setLoadingPage(false);
                setValidToken(true);
                setApiBadRequestNotif(err?.response?.data?.message);
            }
        }

        loadValidToken();
    }, [props.location.search]);

    useEffect(() => {
        if (secondsRedirect > 0)
            setTimeout(() => setSecondsRedirect(secondsRedirect - 1), 1000);

        if (secondsRedirect === 0 && apiGoodRequestNotif) history.push('/');

        if (
            secondsRedirect === 0 &&
            !apiGoodRequestNotif &&
            !apiBadRequestNotif
        )
            history.push('/forgot-password');
    }, [secondsRedirect]);

    if (loadingPage) {
        return <Loading width={250} height={250} />;
    }

    return (
        <div className="resetPassword-body">
            <div
                className="imagesWrapper"
                key={`imagesWrapper-${backgroundRandom}`}>
                <img
                    className="bg-img"
                    src={require(`../../assets/images/background${backgroundRandom}.png`)}
                    alt="background-img"
                />
                <img
                    className="bg-effect"
                    src={require(`../../assets/images/top-right-background-effect.png`)}
                    alt="background-effect"
                />
            </div>
            <div className="loginFormWrapper">
                <img
                    className="form-header-range"
                    src={require('../../assets/images/form-header-range.svg')}
                    alt="form-header-range"
                />
                <div className="loginFormContent">
                    <div className="logo">
                        <img
                            className="logo-neo"
                            src={require('../../assets/images/logo-neo.svg')}
                            alt="Neo"
                        />
                        <img
                            className="text-neo"
                            src={require('../../assets/images/text-neo.svg')}
                            alt="Neo"
                        />
                    </div>
                    <div className="title">
                        <h4>Reset your password</h4>
                        <p>{validToken && 'Enter your new password'}</p>
                    </div>
                    {apiBadRequestNotif && (
                        <Alert
                            variant="danger"
                            onClose={() => setApiBadRequestNotif(false)}
                            dismissible>
                            {apiBadRequestNotif?.additionalData ? (
                                <p>
                                    {apiBadRequestNotif?.message}
                                    <ul>
                                        {apiBadRequestNotif.additionalData.map(
                                            a => (
                                                <li key={a.code}>
                                                    {a.code && a.name
                                                        ? `${a.code} - ${a.name}`
                                                        : a.name}
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </p>
                            ) : (
                                <p>{apiBadRequestNotif}</p>
                            )}
                        </Alert>
                    )}
                    {validToken && !apiGoodRequestNotif ? (
                        <>
                            <Form
                                className="inputs-form"
                                onKeyPress={e =>
                                    e.key === 'Enter' && onSubmit(e)
                                }>
                                <Form.Group className="input-email">
                                    <Form.Control
                                        required
                                        size="lg"
                                        type="password"
                                        placeholder="New password"
                                        name="password"
                                        value={requestForm.password}
                                        onChange={e => {
                                            setRequestForm({
                                                ...requestForm,
                                                password: e.target.value,
                                            });
                                            if (
                                                !apiBadRequestNotif?.additionalData
                                            ) {
                                                setApiBadRequestNotif(false);
                                            }
                                        }}
                                        isInvalid={
                                            validation &&
                                            (!passwordValidation()
                                                .validationPassword ||
                                                requestForm.password === '')
                                                ? true
                                                : false
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Password cannot be empty.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Control
                                        required
                                        size="lg"
                                        type="password"
                                        placeholder="Confirm new password"
                                        name="passwordConfirmation"
                                        value={requestForm.passwordConfirmation}
                                        onChange={e => {
                                            setRequestForm({
                                                ...requestForm,
                                                passwordConfirmation:
                                                    e.target.value,
                                            });
                                            if (
                                                !apiBadRequestNotif?.additionalData
                                            ) {
                                                setApiBadRequestNotif(false);
                                            }
                                        }}
                                        isInvalid={
                                            validation &&
                                            (!passwordValidation()
                                                .validationPasswordConfirmation ||
                                                requestForm.passwordConfirmation ===
                                                    '')
                                                ? true
                                                : false
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Passwords do not match.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form>
                            <Button
                                className="submit-form"
                                variant={
                                    requestForm.password !== ''
                                        ? 'neoPrimary'
                                        : 'neoSecondary'
                                }
                                disabled={loading ? true : false}
                                onClick={e => onSubmit(e)}>
                                {loading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    'Reset'
                                )}
                            </Button>
                            <Link to="/" className="forgot-password">
                                Return to log in
                            </Link>
                        </>
                    ) : apiGoodRequestNotif ? (
                        <>
                            <Alert
                                variant="success"
                                className="resetPassword__notif">
                                Your password has been changed successfully.
                            </Alert>
                            <p className="resetPassword__message">
                                You'll be redirected to the log in page in{' '}
                                {secondsRedirect} seconds.
                                <br />
                                Or click&nbsp;
                                <Link to="/">here</Link>
                                &nbsp;to redirect now.
                            </p>
                        </>
                    ) : (
                        <>
                            <Alert
                                variant="danger"
                                className="resetPassword__notif">
                                Invalid or expired token.
                            </Alert>
                            <p className="resetPassword__message">
                                <br />
                                You will be redirected to make a new password
                                request at {secondsRedirect} seconds.
                                <br />
                                Or click&nbsp;
                                <Link to="/forgot-password">here</Link>
                                &nbsp;to redirect now.
                            </p>
                        </>
                    )}
                </div>
                <div className="poweredBy">
                    <a className="by-antares" href="#">
                        powered by
                    </a>
                    <br></br>
                    <img
                        className="logo-antares"
                        src={require('../../assets/images/logo-antares.svg')}
                        alt="Antares vision group"
                    />
                </div>
            </div>
        </div>
    );
}
